import debug from 'webmd-debug';
import { nextTick } from 'vue';

/* eslint-disable import/prefer-default-export */
export const adsManagerMixin = {
	data() {
		return {
			isInviewAdRefreshed: false,
		};
	},
	methods: {
		/**
		 * Initializes an IntersectionObserver to track the visibility of Ads.
		 * @param {string|object} adsObj - Either a string representing an Ad ID or
		 * an object containing Ad IDs.
		 */
		initObserver(adsObj) {
			const self = this;
			const observer = new IntersectionObserver(self.observeIntersection);

			const observeTarget = (targetId) => {
				const target = document.getElementById(targetId);
				if (target && !this.isInviewAdRefreshed) {
					debug('[vueVideoPlayer] Observe Ad:', targetId);
					observer.observe(target);
				}
			};

			if (typeof adsObj === 'string') {
				observeTarget(adsObj);
			} else if (typeof adsObj === 'object') {
				Object.keys(adsObj).forEach((key) => observeTarget(key));
			}

			/* eslint-disable */
        },
        /**
         * Handle intersection events for observed elements.
         * @param {IntersectionObserverEntry[]} entries - An array of intersection entries.
         */
        observeIntersection(entries) {
            const self = this;

            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const { target } = entry;

                    // If an element is intersecting, add its ID to the 'displayAdsSet'
                    self.adConfig.displayAdsSet.add(target.id);

                    const validId = window?.webmd?.ads?.disableAdsInit && (target?.id in webmd.ads.ads)
                    && (target.children.length == 0 && self.isInviewAdRefreshed);

                    if (validId) {
                        debug('[vueVideoPlayer] Ad container empty, refresh', target.id);
                        webmd.ads.refresh({ id: target.id });
                    }

                } else {
                    // If an element is no longer intersecting, remove its ID from the 'displayAdsSet'
                    self.adConfig.displayAdsSet.delete(entry.target.id);
                }
            })
        },
        /**
         * Refresh Ads inside display Ads Set, which gets updated by the Observer
         */
        refreshInviewAds() {
            //Add Pixel Ads to the refreshAds Object
            const refreshAds = {'ad-pos-901-1': true, 'ad-pos-922-1': true};

            // Iterate through the ad IDs in the displayAdsSet
            this.adConfig.displayAdsSet.forEach((adId) => {
                // Mark each ad for refreshing
                if (adId in webmd.ads.ads) {
                    refreshAds[adId] = true;
                }
            });

            debug('[vueVideoPlayer] Inview Ads to be refreshed: ', refreshAds);
            // Call the ad refresh method
            webmd.ads.refresh({
                id: refreshAds
            });

            //Wait for the ad in view to refresh
            nextTick(() => {
                this.isInviewAdRefreshed = true;
            });
        },
    }
}